import { AvailableRoom, StaticRoom } from '@features/rooms/types';
import { RoomSchema } from './schemas';
import { Room } from './types';

type MapToRooms = (staticRooms: StaticRoom[], availableRooms: AvailableRoom[]) => Room[];

const sortByPrice = (rooms: Room[]) =>
  rooms.sort((a, b) => (a.price?.amount || Infinity) - (b.price?.amount || Infinity));

export const toRoomItems: MapToRooms = (staticRooms, availableRooms) => {
  const mappedRooms = staticRooms.reduce<Array<Room>>((rooms, { room_id, title, image_url }) => {
    const availableRoom = availableRooms.find(({ id }) => id === room_id);

    const result = RoomSchema.safeParse({
      id: room_id,
      name: title,
      image: {
        url: image_url ?? '',
      },
      price: availableRoom
        ? {
            amount: availableRoom?.price_per_stay?.amount,
            currencyCode: availableRoom?.price_per_stay?.currency_code,
          }
        : null,
    });

    if (result.success) {
      return [...rooms, result.data];
    }

    return [...rooms];
  }, []);

  return sortByPrice(mappedRooms);
};
